module.exports = __webpack_public_path__ + "assets/853ac2aeeb42298d3b87f80fdf1f9486.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-greek-ext-300-normal.woff2
// module id = 2630
// module chunks = 121